/**
 * @generated SignedSource<<5f918ddd4e76977f49be6dad13b59d09>>
 * @relayHash d3e613cd519244eff8a4a90302d91068
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e8f8b7b407e2eea2b5d3ad37de8e3668ccf3ab2f9368581d1c0d4eff1685b179

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AgentOverviewInternalsQuery$variables = {
  helpCenterAri: string;
  isVersioningEnabled: boolean;
};
export type AgentOverviewInternalsQuery$data = {
  readonly csmAi_getAiHubByHelpCenterAri: {
    readonly __typename: "CsmAiHub";
    readonly agent?: {
      readonly " $fragmentSpreads": FragmentRefs<"agentCard_AtlassianCsmAgentOverview">;
    } | null | undefined;
    readonly agents?: ReadonlyArray<{
      readonly versions?: {
        readonly nodes: ReadonlyArray<{
          readonly versionType: string | null | undefined;
        }>;
      } | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"multiVersionAgentSummary_AtlassianCsmAgentOverview">;
    }> | null | undefined;
    readonly id: string;
  } | {
    readonly __typename: "QueryError";
    readonly extensions: ReadonlyArray<{
      readonly errorType: string | null | undefined;
    }> | null | undefined;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
};
export type AgentOverviewInternalsQuery = {
  response: AgentOverviewInternalsQuery$data;
  variables: AgentOverviewInternalsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "helpCenterAri"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isVersioningEnabled"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "helpCenterAri",
    "variableName": "helpCenterAri"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v3 = {
  "kind": "ScalarField",
  "name": "id"
},
v4 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 2
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "versionType"
},
v6 = {
  "kind": "ScalarField",
  "name": "errorType"
},
v7 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "AgentOverviewInternalsQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getAiHubByHelpCenterAri",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              {
                "condition": "isVersioningEnabled",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "agent",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "FragmentSpread",
                        "name": "agentCard_AtlassianCsmAgentOverview"
                      }
                    ]
                  }
                ]
              },
              {
                "condition": "isVersioningEnabled",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "agents",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "FragmentSpread",
                        "name": "multiVersionAgentSummary_AtlassianCsmAgentOverview"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "args": (v4/*: any*/),
                            "concreteType": "CsmAiAgentVersionConnection",
                            "kind": "LinkedField",
                            "name": "versions",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "RequiredField",
                                "field": {
                                  "concreteType": "CsmAiAgentVersion",
                                  "kind": "LinkedField",
                                  "name": "nodes",
                                  "plural": true,
                                  "selections": [
                                    (v5/*: any*/)
                                  ]
                                },
                                "action": "THROW",
                                "path": "csmAi_getAiHubByHelpCenterAri.agents.versions.nodes"
                              }
                            ],
                            "storageKey": "versions(first:2)"
                          }
                        ],
                        "type": "CsmAiMultiVersionAgent"
                      }
                    ]
                  }
                ]
              }
            ],
            "type": "CsmAiHub"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": true,
                "selections": [
                  (v6/*: any*/)
                ]
              }
            ],
            "type": "QueryError"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AgentOverviewInternalsQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getAiHubByHelpCenterAri",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              {
                "condition": "isVersioningEnabled",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "agent",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v3/*: any*/),
                          (v7/*: any*/)
                        ],
                        "type": "CsmAiAgent"
                      }
                    ]
                  }
                ]
              },
              {
                "condition": "isVersioningEnabled",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "agents",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isCsmAiMultiVersionAgentResult"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "agentId"
                          },
                          {
                            "args": (v4/*: any*/),
                            "concreteType": "CsmAiAgentVersionConnection",
                            "kind": "LinkedField",
                            "name": "versions",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "CsmAiAgentVersion",
                                "kind": "LinkedField",
                                "name": "nodes",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "versionNumber"
                                  },
                                  (v5/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "name": "agentIdentityConfig",
                                    "plural": false,
                                    "selections": [
                                      (v2/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v7/*: any*/),
                                          (v3/*: any*/)
                                        ],
                                        "type": "CsmAiAgentIdentity"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "message"
                                          }
                                        ],
                                        "type": "QueryError"
                                      }
                                    ]
                                  }
                                ]
                              }
                            ],
                            "storageKey": "versions(first:2)"
                          }
                        ],
                        "type": "CsmAiMultiVersionAgent"
                      }
                    ]
                  }
                ]
              }
            ],
            "type": "CsmAiHub"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v6/*: any*/)
                ]
              }
            ],
            "type": "QueryError"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "e8f8b7b407e2eea2b5d3ad37de8e3668ccf3ab2f9368581d1c0d4eff1685b179",
    "metadata": {},
    "name": "AgentOverviewInternalsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "2535d14a88dbf30c4d01d277dcd1497a";

export default node;
